import React from 'react'

export default function Footer() {
  return (
    <div>
      <hr/>
      <div className="footstack">
        <div className="p-2" ><a href="https://www.linkedin.com/in/shrinolo/" target="_blank">Contact Us  </a><img src='linkedin.png' style={{height:"20px", width:"20px", opacity:"100%"}}/></div>
        <div className="p-2"><a href="/">Home</a></div>
        <div className="p-2">@ShreyaShrivastava2024</div>
      </div>
    </div>
  )
}
